<template>
	<div class="container">
		<header class="page-header">
			<h1 class="page-title-2">Why Toolaku System?</h1>
		</header>
		<div class="row">
			<div class="col-md-9">
				<p class="lead">In the current business environment, Business opportunities in the Oil and Gas sector are not growing as much as it should and couple with reducing margins. 
				SMEs are facing continuous challenges to sustain their current revenue and business operations due to capacity and competition.
				The business landscape has evolve towards the digital transformation of industry 4.0 and 5.0.
				SMEs business need to strategies their business models towards a challenging and competitive environment plus embracing digital platform.</p>
			</div>
		</div>
		<div class="gap gap-small"></div>
		<div class="row row-col-gap">
			<div class="col-md-8">
				<img class="full-width" src="@/assets/img/web.com.png" alt="Image Alternative text" title="Image Title" />
			</div>
			<div class="col-md-4">
				<h3 class="widget-title">Benefits</h3>
				<p>1)	Enabling SMEs to leverage innovation and technology to grow and compete more effectively in domestic and global economies.</p>
				<p>2)	Benefit of using Toolaku is it have instant access to a countless number of suppliers who sell and offer product and services that are related to Oil and Gas industry.</p>
				<p>3)	SMEs can get free website and will able to started listing and promoting their products and services for free.</p>
				<p>4)	As a member of Toolaku, SMEs can get multiple modules such as products, services, project management, HR and finance.</p>
			</div>
		</div>
		<div class="gap gap-small"></div>
		<div class="row row-col-gap">
			<div class="col-md-6">
				<div class="gap gap-small"></div>
				<h3 class="widget-title">About Us</h3>
				<p>Toolaku is Malaysia’s collaboration platform in oil and gas industry and was established in 2020 to provide a range of business-to-business (B2B) services, catered to both small and large enterprises in Malaysia.</p>
				<p>Designed to serve the oil and gas company needs to promote its products and services online. Visitors to Toolaku will find the latest oil and gas products, new product updates; information on technology, exploration, oilfield services, equipment, supplies and much more.</p>
				<p>The leading providers of products and services in the industry have recognized the benefits of being part of the Toolaku community. Toolaku provides customers and prospects with a way to cut through the Internet clutter and put their company in a position to be discovered in an increasingly crowded medium.</p>
			</div>
			<div class="col-md-2"></div>
			<div class="col-md-4">
				<img class="full-width" src="@/assets/img/collab.png" alt="Image Alternative text" title="Image Title" />
			</div>
		</div>
		<div class="gap gap-small"></div>
		<div class="gap gap-small"></div>
		<div class="gap gap-small"></div>
		<div class="row row-col-gap">
			<div class="col-md-1"></div>
			<div class="col-md-4">
				<img class="full-width" src="@/assets/img/mission-icon-27.png" alt="Image Alternative text" title="Image Title" />
			</div>
			<div class="col-md-2"></div>
			<div class="col-md-4">
				<div class="gap gap-small"></div>
				<div class="gap gap-small"></div>
				<h3 class="widget-title">Vision</h3>
				<p>To solve the challenges of SME in procurement, management, financing, sales and marketing through information technology</p>
				<br><br>
				<h3 class="widget-title">Mission</h3>
				<p>To become a main centre for SME business to find information.</p>
			</div>
			<div class="col-md-2"></div>
			<div class="col-md-4">
				<h3 class="widget-title"></h3>
				<p></p>
			</div>
		</div>
		<div class="gap gap-small"></div>
	</div>
</template>

<script>
	export default {
		components: {
			//
		},
		data() {
			return {
				authKey: null
			}
		},
		created() {
			  //
		}
	}
</script>
